import React from 'react';

import { Navigate, useLocation } from 'react-router-dom';

import { ReturnComponentType } from 'common';
import { Paths } from 'enums';
import { useAppSelector } from 'hooks';
import { selectAccessToken } from 'state';

export const ProtectedRoute = ({ children }: any): ReturnComponentType => {
  const location = useLocation();
  const token = useAppSelector(selectAccessToken);

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return token ? <>{children}</> : <Navigate to={Paths.LOGIN} replace state={location} />;
};
